export const NavbarLinks = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'About Us',
    link: '/about-us',
  },

  {
    label: 'Services',
    link: '/services',
    sublinks: [
      {
        label: 'Cleaning Services',
        link: '/cleaning-services',
      },
      {
        label: 'Home Extensions',
        link: '/home-extensions',
      },
      {
        label: 'Gardening Services',
        link: '/gardening-services',
      },
      {
        label: 'Painting Services',
        link: '/painting-services',
      },
      {
        label: 'Roofing Services',
        link: '/roofing-services',
      },
      {
        label: 'Plumbing Services',
        link: '/plumbing-services',
      },
      {
        label: 'Tiling Services',
        link: '/tiling-services',
      },
      {
        label: 'Ground Work Services',
        link: '/groundwork-services',
      },
      {
        label: 'Kitchen Fitting Services',
        link: '/kitchen-fitting-services',
      },
      {
        label: 'Electrical Works',
        link: '/electrical-works',
      },
      {
        label: 'Flat Refurbishment',
        link: '/flat-refurbishment',
      },
      {
        label: 'Carpet & Flooring',
        link: '/flooring-services',
      },
      {
        label: 'Small Repairs',
        link: '/small-repairs',
      },
      {
        label: 'Building Maintenance',
        link: '/building-maintenance',
      },
      {
        label: 'Bathroom Fittings',
        link: '/bathroom-fittings',
      },
      {
        label: 'Landscaping Services',
        link: '/landscaping-service',
      },
    ],
  },

  {
    label: 'Contact Us',
    link: '/contact-us',
  },
  {
    label: 'More',
    sublinks: [
      {
        label: 'Terms & Conditions',
        link: '/terms-conditions',
      },
      {
        label: 'Privacy Policy',
        link: '/privacy-policy',
      },
    ],
  },
];
